import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { motion } from "framer-motion";
import { FaDownload, FaBookOpen } from "react-icons/fa";
import "./ResearchPublications.css";

const ResearchPublications = () => {
  const publications = [
    {
      title:
        "Vikash Publishes a book : The Journey of Community Based Rehabilitation(CBR)",
      description:
        "The book describes the change brought in the lives of 500 children in Gop block of Puri district in Odisha...",
      pdfUrl: "assets/files/11.pdf",
      size: "4.2 MB",
    },
    {
      title:
        "Conservation of Soil and Water is the key to Environmental Sustainability",
      description:
        "Conservation of soil and water resources is important for sustainability of agriculture and environment...",
      pdfUrl: "assets/files/22.pdf",
      size: "2.8 MB",
    },
    {
      title:
        "Eco Village Development Plan for management of natural springs.",
      description:
        "The document focuses upon the key strategies, its approach and the expected outcomes of village development...",
      pdfUrl: "assets/files/33.pdf",
      size: "3.6 MB",
    },
    {
      title:
        "Impact of Natural stream management in the Bonda hills of Malkangiri",
      description:
        "The life changing outcomes that has generated the well being in the life of people residing in Bonda hills...",
      pdfUrl: "assets/files/44.pdf",
      size: "3.1 MB",
    },
    {
      title:
        "Training Module For Village Leaders Training on Climate Change.",
      description:
        "This module focuses upon the training programme conducted for the village level leaders in local...",
      pdfUrl: "assets/files/55.pdf",
      size: "2.4 MB",
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: { y: 0, opacity: 1 },
  };

  return (
    <>
      <Header />

      {/* ================= Hero (1521 x 482) ================= */}
      <section className="rp-page">
        <div className="rp-container">
          <div className="rp-hero">
            <div
              className="rp-hero__image"
              style={{ backgroundImage: "url(assets/images/backgrounds/Research.jpg)" }}
            />
            <div className="rp-hero__overlay" />
            <div className="rp-hero__content">
              <motion.h2
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                className="rp-hero__title"
              >
                Research & Publications
              </motion.h2>
              <motion.p
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.3 }}
                className="rp-hero__text"
              >
                Vikash's research and publications offer insights into our work
              </motion.p>
            </div>
          </div>
        </div>
      </section>

      {/* ================= Main list ================= */}
      <div className="container rp-main">
        <div className="text-center rp-main__header">
          <motion.h1
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="rp-heading"
          >
            Research & Publications
          </motion.h1>
          <span className="rp-heading__underline" />
        </div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {publications.map((pub, index) => (
            <motion.a
              key={index}
              href={pub.pdfUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="rp-cardLink"
              variants={itemVariants}
            >
              <div className="rp-card">
                <span className="rp-card__index">{String(index + 1).padStart(2, "0")}</span>

                <span className="rp-card__pdfIcon">
                  <span className="rp-card__pdfIcon-corner" />
                  PDF
                </span>

                <div className="rp-card__body">
                  <h5 className="rp-card__title">{pub.title}</h5>
                  <p className="rp-card__text">{pub.description}</p>
                </div>

                <div className="rp-card__download">
                  <span className="rp-card__downloadLabel">Download PDF</span>
                  <span className="rp-card__downloadIcon">
                    <FaDownload />
                  </span>
                  <span className="rp-card__size">{pub.size}</span>
                </div>
              </div>
            </motion.a>
          ))}
        </motion.div>

        {/* ================= CTA ================= */}
        <motion.div
          className="rp-cta"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <div
            className="rp-cta__bg"
            style={{ backgroundImage: "url(assets/images/sections/research-books.jpg)" }}
          />
          <div className="rp-cta__overlay" />
          <div className="rp-cta__content">
            <span className="rp-cta__icon">
              <FaBookOpen />
            </span>
            <h3 className="rp-cta__title">Knowledge for Impact</h3>
            <span className="rp-cta__underline" />
            <p className="rp-cta__text">
              Our research drives solutions that create meaningful change in
              communities and the environment.
            </p>
          </div>
        </motion.div>
      </div>

      <Footer />
    </>
  );
};

export default ResearchPublications;